import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Card, CardHeader, CardTitle } from "@shared/ui/card";
import { Gauge, Network, Package, Settings } from "lucide-react";
import React from "react";

interface FacilityKeyMetricsRowProps {
  data: {
    currentCapacity: string;
    overallDesignCapacity: string;
    systemsCount: number;
    networksCount: number;
    assetsCount: number;
  };
}

export const FacilityKeyMetricsRow: React.FC<FacilityKeyMetricsRowProps> = ({
  data,
}) => {
  const statsData = [
    {
      title: "Current Capacity (MLD)",
      count: `${data.currentCapacity || 0}/${data.overallDesignCapacity || 0}`,
      icon: <Gauge className="h-8 w-8 text-blue-500" />,
      tooltip:
        "The facility's current operational throughput compared to its maximum design capacity.",
    },
    {
      title: "Systems",
      count: data.systemsCount || 0,
      icon: <Settings className="h-8 w-8 text-purple-500" />,
      tooltip: "The total number of systems that make up this facility.",
    },
    {
      title: "Networks",
      count: data.networksCount || 0,
      icon: <Network className="h-8 w-8 text-green-500" />,
      tooltip:
        "The number of connected networks associated with this facility.",
    },
    {
      title: "Assets",
      count: data.assetsCount || 0,
      icon: <Package className="h-8 w-8 text-orange-500" />,
      tooltip:
        "The total number of individual assets (e.g., pumps, valves, filters) across all systems in this facility.",
    },
  ];

  return (
    <Card>
      <CardHeader className="pb-4">
        <div className="flex items-center gap-2">
          <div className="text-xs">📊</div>
          <CardTitle className="text-lg font-semibold">Key Metrics</CardTitle>
        </div>
        <p className="text-sm text-gray-600">
          Current operational metrics and performance indicators
        </p>
      </CardHeader>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {statsData.map((stat, index) => (
          <QuickStatsCard
            key={index}
            title={stat.title}
            count={stat.count}
            icon={stat.icon}
            tooltip={stat.tooltip}
          />
        ))}
      </div>
    </Card>
  );
};
